import clsx from 'clsx';
import StageBox from '../StageBox/StageBox';
import styles from './BenefitsStagebox.module.scss';
import BenefitsStageboxDetail from './BenefitsStageboxDetail/BenefitsStageboxDetail';
import BenefitsStageboxDetails from './BenefitsStageboxDetails/BenefitsStageboxDetails';
import BenefitsStageboxSubtitle from './BenefitsStageboxSubtitle/BenefitsStageboxSubtitle';
import BenefitsStageboxTitle from './BenefitsStageboxTitle/BenefitsStageboxTitle';
import type { BenefitsStageboxProps } from './types';

const BenefitsStagebox = ({
  children,
  className,
  buttonSlot,
}: BenefitsStageboxProps) => {
  return (
    <div className={clsx(styles.base, className)}>
      <StageBox backgroundType="white" hasShadow>
        <div className={styles.content}>
          {children}
          {buttonSlot}
        </div>
      </StageBox>
    </div>
  );
};

BenefitsStagebox.Title = BenefitsStageboxTitle;
BenefitsStagebox.Subtitle = BenefitsStageboxSubtitle;
BenefitsStagebox.Details = BenefitsStageboxDetails;
BenefitsStagebox.Detail = BenefitsStageboxDetail;

export default BenefitsStagebox;
